import React from 'react'

import type { WaveLinkHeaderProps } from 'routes/Menu/MenuRecipesPage/CollectionHeader/WaveLinkHeader/WaveLinkHeader'
import type { MenuHeadersIncludesData } from 'routes/Menu/domains/brand/types'

import { WaveLinkHeader } from '../WaveLinkHeader'
import { useWaveLinkHeaderClick } from './useWaveLinkHeaderClick'

type OwnProps = {
  link: MenuHeadersIncludesData['attributes']['link']
}

const WaveLinkHeaderContainer = (props: Omit<OwnProps & WaveLinkHeaderProps, 'onClick'>) => {
  const { link } = props
  const onClick = useWaveLinkHeaderClick(link?.collectionId, link?.collectionSlug)

  // eslint-disable-next-line react/jsx-props-no-spreading
  return <WaveLinkHeader {...props} onClick={onClick} />
}

export { WaveLinkHeaderContainer }
